import { useMemo } from "react";
import PageContentType from "../PageContentType";

interface useProjectInfoProps {
    projects: any[];
    currentProjectInfo: any | null;
    pageContentType: PageContentType | null;
}

const useActiveProjects = ({ projects, currentProjectInfo, pageContentType }: useProjectInfoProps) => {
    const currentActiveProjects = useMemo(() => {
        if (pageContentType == PageContentType.PROJECT || pageContentType == PageContentType.DELIVERY) {
            return currentProjectInfo ? [currentProjectInfo] : [];
        }

        return projects;
    }, [projects, pageContentType, currentProjectInfo]);

    return {
        currentActiveProjects,
    };
};

export default useActiveProjects;
